import { ApiService } from '../services/api_service';
import { i18n } from './i18n';

// !!!!! Achtung, ist nur temporär um für die  Kommunalverwaltung schnell die Begrifflichkeiten anzupassen
// Es gibt bereits eine andere i18n - Funktion, diese führen wir dann zeitnah korrekt zusammen

export function i18n2(key: string) {
    const map = getLanguageMap('de', ApiService.bereichKey);
    if (map[key]) {
        return map[key];
    }
    return i18n(key, 'sys');
}

function getLanguageMap(lang: string, bereich: string) {
    if (lang === 'de' && bereich === 'kommunalverwaltung') {
        return {
            'Geschäftsreisen': i18n('Dienstreisen', 'sys'),
            '6. Geschäftsreisen': `6. ${i18n('Dienstreisen', 'sys')}`,
            'Betriebliche Daten': i18n('Stammdaten', 'sys'),
        } as any;
    }
    return {};
}
